export const CURRENCY_TYPE_SYMBOLS = {
  Eur: '\u20ac',
  Rur: '\u20bd',
  Usd: '\u0024',
};

export const SQUARE_SYMBOLS = {
  Hectare: 'га',
  HundredSquareMeters: 'сот.',
  SquareMeter: 'м\u00B2',
};
